<template>
  <div class="outer-layer">
    <div class="tool-hander">
      <el-row  :gutter="10" type="flex"  style="min-height: 100%;">
        <el-col :span="5">
          <div class="logo"></div>
        </el-col>
      </el-row>
    </div>
    <div class="tool-main">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="用户名称">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="用户密码">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="form.password2"></el-input>
        </el-form-item>
        <el-form-item label="申请方式">
          <el-select v-model="form.region" placeholder="请选择申请方式">
            <el-option label="手机号" value="shanghai"></el-option>
            <el-option label="微信" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送短信">
          <el-switch v-model="form.delivery"></el-switch>
        </el-form-item>
        <el-form-item label="注册类型">
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="智能" name="type"></el-checkbox>
            <el-checkbox label="地推活动" name="type"></el-checkbox>
            <el-checkbox label="线下主题活动" name="type"></el-checkbox>
            <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="注册类型">
          <el-radio-group v-model="form.resource">
            <el-radio v-model="radio" label="1">智慧楼宇</el-radio>
            <el-radio v-model="radio" label="2">智慧园区</el-radio>
            <el-radio v-model="radio" label="3">智慧工地</el-radio>
            <el-radio v-model="radio" label="4">数字园区</el-radio>
            <el-radio v-model="radio" label="5">智慧场馆</el-radio>
            <el-radio v-model="radio" label="6">智慧医院</el-radio>
            <el-radio v-model="radio" label="7">市政设施</el-radio>
            <el-radio v-model="radio" label="8">智慧交通</el-radio>
            <el-radio v-model="radio" label="9">环保监测</el-radio>
            <el-radio v-model="radio" label="10">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolRegister',
  props: {
    show: {

    },
  },
  components: {

  },
  data () {
    return {
      form: {
        username: '',
        password:'',
        password2:'',
        region: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    onSubmit() {
      console.log('submit!');
    }
  }
}
</script>
<style scoped>
  .outer-layer{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  .tool-hander{
    width: 100%;
    height: 5%;
    background-color: #dedede;
  }
  .logo{
    width: 30%;
    height: 70%;
    background-image: url("/static/img/logOne.png");
    background-size: 100% 100%;
    margin-left: 15px;
    margin-top: 1.5%;
  }
  .tool-main{
    width: 30%;
    height: 80%;
    margin: 0 auto;
    margin-top: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/homePageAssembly/toolregister.vue